class MenuAccordion extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.button = this.querySelector(".menu-accordion--button");
    this.content = this.querySelector(".menu-accordion--content");
    this.inner = this.querySelector(".menu-accordion--inner");

    this.onClick = this.toggleButton.bind(this);

    this.button.addEventListener("click", this.onClick);
  }

  disconnectedCallback() {
    this.button.removeEventListener("click", this.onClick);
  }

  toggleButton() {
    if(this.classList.contains("open")) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.content.style.setProperty("--height", `${this.inner.getBoundingClientRect().height}px`);
    this.classList.add("open");
  }

  close() {
    this.classList.remove("open");
  }
}

customElements.define("menu-accordion", MenuAccordion);

window.addEventListener('DOMContentLoaded', function() {
  /* Filter show more/less functionality */
  const filterToggles = document.querySelectorAll('[data-filter-toggle]');
  
  filterToggles.forEach(toggle => {
    toggle.addEventListener('click', function() {
      const filterList = this.previousElementSibling;
      const hiddenItems = filterList.querySelectorAll('[data-filter-item].filter-item--hidden');
      const showMoreText = this.querySelector('[data-show-more-text]');
      const showLessText = this.querySelector('[data-show-less-text]');
      
      if (hiddenItems.length > 0 && hiddenItems[0].classList.contains('filter-item--hidden')) {
        // Show all items
        hiddenItems.forEach(item => {
          item.classList.remove('filter-item--hidden');
        });
        showMoreText.style.display = 'none';
        showLessText.style.display = 'inline';
      } else {
        // Hide items after index 3
        const allItems = filterList.querySelectorAll('[data-filter-item]');
        allItems.forEach((item, index) => {
          if (index >= 3) {
            item.classList.add('filter-item--hidden');
          }
        });
        showMoreText.style.display = 'inline';
        showLessText.style.display = 'none';
      }
    });
  });

  /* Mega Menu */
  const megaMenuItems = document.querySelectorAll('.mega-menu__collection--item[data-id]');

  for(const megaMenuItem of megaMenuItems) {
    megaMenuItem.addEventListener('mouseover', function() {
      document.querySelector('.mega-menu__collection--product-container.active').classList.remove('active');
      activeItem = document.querySelector(`.mega-menu__collection--product-container[data-id="${megaMenuItem.dataset.id}"]`);
      if(activeItem) {
        activeItem.classList.add('active');
      }
    });
  }
});